import { PERMISSIONS } from '@/shared/constants/permissions';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const RemovePermissionFromRoleDtoSchema = z.object({
  permissionCode: z.enum(PERMISSIONS),
  roleId: z.number(),
});

const RemovePermissionFromRoleResponseDtoSchema = z.string();

export type RemovePermissionFromRoleRequestDto = z.infer<
  typeof RemovePermissionFromRoleDtoSchema
>;
export type RemovePermissionFromRoleResponseDto = z.infer<
  typeof RemovePermissionFromRoleResponseDtoSchema
>;

export const removePermissionFromRole = (
  dto: RemovePermissionFromRoleRequestDto,
  config?: AxiosRequestConfig<RemovePermissionFromRoleRequestDto>
) => {
  const data = RemovePermissionFromRoleDtoSchema.parse(dto);
  return api
    .delete('/roles/permissions', { data, ...config })
    .then(responseContract(RemovePermissionFromRoleResponseDtoSchema));
};
